// Som do sino de notificações — chime curto (2 notas) via WebAudio, sem arquivo.
// AudioContext é lazy/singleton e é "armado" no primeiro gesto do usuário (política
// de autoplay dos navegadores: sem gesto, não há som — o contador atualiza normal).
let ctx: AudioContext | null = null;
let armListenerInstalled = false;

function ensureCtx(): AudioContext {
  if (!ctx) {
    const W = window as unknown as { AudioContext?: typeof AudioContext; webkitAudioContext?: typeof AudioContext };
    const Ctor = W.AudioContext || W.webkitAudioContext;
    if (!Ctor) throw new Error('WebAudio não suportado');
    ctx = new Ctor();
  }
  if (ctx.state === 'suspended') void ctx.resume();
  return ctx;
}

function installArmListener(): void {
  if (armListenerInstalled) return;
  armListenerInstalled = true;
  const arm = () => {
    try { ensureCtx(); } catch { /* sem WebAudio */ }
    window.removeEventListener('pointerdown', arm);
    window.removeEventListener('keydown', arm);
  };
  window.addEventListener('pointerdown', arm, { once: true });
  window.addEventListener('keydown', arm, { once: true });
}

export function useNotificationSound() {
  installArmListener();

  function play(): void {
    try {
      const c = ensureCtx();
      if (c.state !== 'running') return; // ainda sem gesto do usuário — silencia
      const start = c.currentTime;
      const notes = [880, 1174.66]; // A5, D6 — "ding" curto
      notes.forEach((freq, i) => {
        const t = start + i * 0.09;
        const osc = c.createOscillator();
        const gain = c.createGain();
        osc.type = 'sine';
        osc.frequency.value = freq;
        gain.gain.setValueAtTime(0.0001, t);
        gain.gain.exponentialRampToValueAtTime(0.18, t + 0.02);
        gain.gain.exponentialRampToValueAtTime(0.0001, t + 0.4);
        osc.connect(gain).connect(c.destination);
        osc.start(t);
        osc.stop(t + 0.45);
      });
    } catch {
      /* ignore — browser sem WebAudio ou bloqueado por política */
    }
  }

  return { play };
}
